module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-600x338-f84156fc78d17a0ffa234f36738ded77.png";